import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    method: String,
    returnUrl: { type: String, default: "/" }
  }

  nativeEventName = "native-2fa-completed"

  connect() {
    this.handleNativeCompleted = this.onNativeCompleted.bind(this)
    window.addEventListener(this.nativeEventName, this.handleNativeCompleted)

    if (window.TurboNativeBridge) {
      window.TurboNativeBridge.postMessage("2fa_required", {
        twoFAMethod: this.methodValue,
        eventName: this.nativeEventName
      })
    }
  }

  disconnect() {
    window.removeEventListener(this.nativeEventName, this.handleNativeCompleted)
  }

  onNativeCompleted() {
    Turbo.visit(this.returnUrlValue)
  }
}
